// import { useLocation, useNavigate } from "react-router-dom";

import { Chip } from "@mui/material";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import { useEffect } from "react";
import { tagsParser } from "utils/helpers/tagsParser";

const ChipList = ({ items, onRemove, title }) => {
  return (
    <MDBox display="flex">
      {title && (
        <MDBox mr={2}>
          <MDTypography variant="h5">{title}</MDTypography>
        </MDBox>
      )}
      <MDBox sx={{ display: "flex", flexWrap: "wrap" }}>
        {items.map((item, index) => (
          <Chip
            key={item.key}
            color="info"
            sx={{ textTransform: "uppercase", mx: 0.5, mb: 0.5 }}
            label={item.title}
            onDelete={onRemove ? () => onRemove(item.title, item.key, index) : undefined}
            size="small"
          />
        ))}
      </MDBox>
    </MDBox>
  );
};

export default ChipList;
